import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  template: `
    <h2>¿Estás seguro?</h2>
    <p>A continuación se va a cancelar la cotización, desea confirmar?</p>
    <button mat-button (click)="onConfirm()">Confirmar</button>
    <button mat-button (click)="onCancel()">Cancelar</button>
  `,
})
export class ConfirmCancelCotizacionComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ConfirmCancelCotizacionComponent>
  ) { }

  ngOnInit(): void {
  }
  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
